import { render, staticRenderFns } from "./multiSelectCategory.vue?vue&type=template&id=184a2b41&"
import script from "./multiSelectCategory.vue?vue&type=script&lang=js&"
export * from "./multiSelectCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports